var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"css-tr"},[_c('div',{staticClass:"css-th align right w-f7"}),_c('div',{staticClass:"css-td"},[_c('i',{staticClass:"icon icon-folder-plus"}),_c('a',{staticClass:"underline fn-sm",on:{"click":_vm.showInvoiceModal}},[_vm._v(" 使用統編記事本 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }